import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  background: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryLight : COLORS.white};
  border: ${({ $isSelected }) =>
    $isSelected ? `1px solid ${COLORS.borderColor}` : '1px solid transparent'};
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: ${COLORS.primaryLight};
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  gap: 4px;
`

export const CheckmarkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`
